import { code,userLogin,userLogout,userForgetPwd,userRegister } from '@/api/login'
import { setToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import * as types from '../mutaion-types'
import storage from '@/utils/storage'

const setViews = visitedViews => {
  storage.set('visitedViews', visitedViews)
}

const user = {
  state: {
    token: '',
    nickname: '',
    name: '',
    avatar: '',
    uid: '',
    menus: []
  },
  mutations: {
    [types.SET_TOKEN]: (state, token) => {
      state.token = token
    },
    [types.SET_NICKNAME]: (state, nickname) => {
      state.nickname = nickname
    },
    [types.SET_UID]: (state, uid) => {
      state.uid = uid
    },
    [types.SET_NAME]: (state, name) => {
      state.name = name
    },
    [types.SET_AVATAR]: (state, avatar) => {
      state.avatar = avatar
    },
    [types.SET_MENUS]: (state, menus) => {
      state.menus = menus
    },
    [types.CLOSE_ALL_TAG]: state => {
      state.visitedViews = []
      setViews([])
    }
  },
  actions: {
    code({ commit },{ areaCode,mobile }){
    	return new Promise(async (resolve, reject) => {
        try {
          const response = await code(areaCode, mobile)
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    },
    userLogin({ commit },{ username,password }){
    	return new Promise(async (resolve, reject) => {
        try {
          const response = await userLogin(username, password)
          
          var data = response.data.data;
          commit(types.SET_TOKEN,data.token)
          commit(types.SET_NAME,data.username)
          commit(types.SET_AVATAR, data.avatar)
          commit(types.SET_NICKNAME,data.nickname)
          commit(types.SET_UID,data.uid)
          commit(types.SET_MENUS,data.menus)
          setToken(data.token)
          Cookies.set("srs_nickname",data.nickname);
          Cookies.set("srs_avatar",data.avatar);
          Cookies.set("user",data.username)
          Cookies.set("menus",data.menus)
          
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    },
    userLogout({ commit }){
    	return new Promise(async (resolve, reject) => {
        try {
          const response = await userLogout()
          Cookies.remove('user')
          commit(types.CLOSE_ALL_TAG);
          removeToken()
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    },
    userForgetPwd({ commit },{areaCode,mobile,randomcode,password}){
    	return new Promise(async (resolve, reject) => {
        try {
          const response = await userForgetPwd(areaCode,mobile,randomcode,password)
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    },
    userRegister({ commit },{mobile,randomcode,password}){
    	return new Promise(async (resolve, reject) => {
        try {
          const response = await userRegister(mobile,randomcode,password)
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    }
  }
}

export default user
